// extracted by mini-css-extract-plugin
module.exports = {"partnerInfoWrapper":"ese4B","partnerIntoContent":"bKVc2"};